import api from "utils/axios";

export async function getNotificationHistory(page = 1, limit = 10) {
  try {
    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/notifications/get-notifications`, {
      params: {page, limit}
    });

    console.log(data);

    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to get plans");
    }

    const { notifications, ...pagination } = data.data;

    return {
      success: true,
      data: notifications,
      pagination,
      message: "Notification history fetched successfully",
    };
  } catch (error) {
    console.error("getNotificationHistory error:", error);
    throw new Error("Failed to fetch notification history");
  }
}

export async function sendNotification(notificationData) {
  try {
    const { data } = await api.post(`${process.env.REACT_APP_BASE_URL}/notifications/send-notifications`, notificationData);

    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to get plans");
    }

    const newNotification = data.data;

    return {
      success: true,
      data: newNotification,
      message: "Notification sent successfully",
    };
  } catch (error) {
    console.error("sendNotification error:", error);
    throw new Error("Failed to send notification");
  }
}